import { Link } from "react-router-dom";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import SEO from "components/SEO";

function NotFound() {
  return (
    <>
      <SEO
        title="Página no encontrada - Gestoría Moreno Granada"
        robots="noindex, nofollow"
        canonicalUrl="/404"
      />
      <MKBox
        minHeight="100vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{ background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)" }}
      >
        <Container>
          <Grid container justifyContent="center">
            <Grid item xs={12} md={8} lg={6} textAlign="center">
              <MKTypography variant="h1" color="dark" sx={{ fontSize: "6rem", fontWeight: 700 }}>
                404
              </MKTypography>
              <MKTypography variant="h4" color="dark" mb={2}>
                Página no encontrada
              </MKTypography>
              <MKTypography variant="body1" color="text" mb={4}>
                Lo sentimos, la página que buscas no existe o ha sido movida.
              </MKTypography>
              <MKButton component={Link} to="/" variant="gradient" color="info" size="large">
                Volver al inicio
              </MKButton>
            </Grid>
          </Grid>
        </Container>
      </MKBox>
    </>
  );
}

export default NotFound;
